import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          await refresh();
          if (!cancelled) setStatus("paid");
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        if (cancelled) return;
        if (attempts < 8) setTimeout(poll, 2500);
        else setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [params, refresh]);

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-6">
      <div className="card-c max-w-md w-full text-center page-enter">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-primary-c mx-auto animate-spin" />
            <h1 className="font-display text-2xl mt-4">Vérification du paiement…</h1>
            <p className="text-text-secondary text-sm mt-2">Quelques instants.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-primary-c mx-auto" />
            <h1 className="font-display text-3xl mt-4">Merci ! <span className="font-serif-italic">Abonnement actif.</span></h1>
            <p className="text-text-secondary text-sm mt-2">Bienvenue dans Oresto. Vous pouvez maintenant gérer votre restaurant sans limite.</p>
            <button onClick={() => navigate("/app/accueil")} data-testid="billing-back-button" className="btn-primary mt-6 w-full">Retour à l'application</button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <h1 className="font-display text-2xl">Paiement non confirmé</h1>
            <p className="text-text-secondary text-sm mt-2">Vous pouvez réessayer depuis l'onglet Plus.</p>
            <button onClick={() => navigate("/app/plus")} className="btn-primary mt-6 w-full">Retour</button>
          </>
        )}
      </div>
    </div>
  );
}
